import React, { useState } from 'react'
import { QuickActionCard } from './BalanceCard'
import Airtime from '../../Assets/Images/airtime.svg'
import Data from '../../Assets/Images/data.svg'
import Cable from '../../Assets/Images/cable.svg'
 import Electricity from '../../Assets/Images/electricity.svg'
 import AirtimeComp from './QuickAction/Airtime'
 import DataComp from './QuickAction/Data'
import CableComp from './QuickAction/Cable'
import ElecComp from './QuickAction/Electricity'
import { FaPhoneVolume } from "react-icons/fa6";
import { IoMdWifi } from "react-icons/io";
import { IoMdTv } from "react-icons/io";
import { MdElectricBolt } from "react-icons/md";

const QuickAction = () => {
  // modal initialization for airtime
  const [airtime, setAirtime] = useState(false);
  const airtimeOpen = () => setAirtime(true);
  const airtimeClose = () => setAirtime(false);

  // modal initialization for data
  const [data, setData] = useState(false);
  const dataOpen = () => setData(true);
  const dataClose = () => setData(false);

  // modal initialization for cable
  const [cable, setCable] = useState(false);
  const cableOpen = () => setCable(true);
  const cableClose = () => setCable(false);

  // modal initialization for electricity
  const [elec, setElec] = useState(false);
  const elecOpen = () => setElec(true);
  const elecClose = () => setElec(false);

  const card = [
    {
      icon: FaPhoneVolume,
      actionName: 'Buy Airtime',
     children: <AirtimeComp closeIcon={airtimeClose} />,
      open: airtime,
      handleOpen: airtimeOpen,
      handleClose: airtimeClose,
    },
    {
      icon: IoMdWifi,
      actionName: 'Buy Data',
      open: data,
      handleOpen: dataOpen,
      handleClose: dataClose,
    children: <DataComp closeIcon={dataClose}/>
    },
    {
      icon: IoMdTv,
      actionName: 'Cable Payment',
      open: cable,
      handleOpen: cableOpen,
      handleClose: cableClose,
      children: <CableComp closeIcon={cableClose} />
    },
    {
      icon: MdElectricBolt,
      actionName: 'Electricity Payment',
      open: elec,
      handleOpen: elecOpen,
      handleClose: elecClose,
      children: <ElecComp closeIcon={elecClose} />
    },
  ]
  return (
    <div className='w-full rounded-lg shadow-md bg-white p-5'>
      <h1 className='text-[21px] font-[500] mb-2'>
      Quick actions
      </h1>
      <QuickActionCard card={card} />
    </div>
  )
}

export default QuickAction